var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('member-invoke',{ref:"members",attrs:{"visible":_vm.show,"source-datas":_vm.newSourceDatas,"default-value":_vm.defaultValue,"is-must-last":true},on:{"change":_vm.handleCascaderSub,"update":_vm.updateShow}})}
var staticRenderFns = []

export { render, staticRenderFns }